/* eslint-disable @typescript-eslint/no-explicit-any */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useMemo, useState } from 'react';
import { ResponsiveLine } from '@nivo/line';
import { Box, Flex, Spacer } from '@tapresearch/ui/components';
import { CustomControlLegend } from './CustomControlLegend';
import { getChartWaveLabels } from './getChartWaveLabels';
import { LineChartLegend } from './LineChartLegend';
import { LineChartSliceTooltip } from './LineChartSliceTooltip';
import { useColorScheme } from './useColorScheme';
import { getLineChartTickValues } from './getLineChartTickValues';
export var ResponsiveLineChart = function(_param) {
    var _Math;
    var data = _param.data, waves = _param.waves, _param_legendDirection = _param.legendDirection, legendDirection = _param_legendDirection === void 0 ? 'column' : _param_legendDirection, customLegendControlProps = _param.customLegendControlProps, customLegendType = _param.customLegendType, usePercentage = _param.usePercentage, rest = _object_without_properties(_param, [
        "data",
        "waves",
        "legendDirection",
        "customLegendControlProps",
        "customLegendType",
        "usePercentage"
    ]);
    var _useState = _sliced_to_array(useState([]), 2), visiblePoints = _useState[0], setVisiblePoints = _useState[1];
    var chartColors = useColorScheme();
    var chartWaveLabels = getChartWaveLabels(waves);
    var tickValues = useMemo(function() {
        return getLineChartTickValues(data);
    }, [
        data
    ]);
    var maxValue = (_Math = Math).max.apply(_Math, _to_consumable_array(tickValues));
    var upperLimit = usePercentage ? maxValue : maxValue + maxValue / 5;
    var dataColors = useMemo(function() {
        return _to_consumable_array(chartColors).map(function(pointColor, i) {
            return !!visiblePoints.length && !visiblePoints.includes(i) ? 'transparent' : pointColor;
        });
    }, [
        chartColors,
        visiblePoints
    ]);
    var handleLegendClick = useCallback(function(answerIndex) {
        var numVisible = visiblePoints.length;
        if (visiblePoints.includes(answerIndex)) {
            setVisiblePoints(numVisible === 1 ? [] : _to_consumable_array(visiblePoints).filter(function(idx) {
                return idx !== answerIndex;
            }));
        } else {
            setVisiblePoints(numVisible + 1 === data.length ? [] : _to_consumable_array(visiblePoints).concat([
                answerIndex
            ]));
        }
    }, [
        data,
        visiblePoints
    ]);
    var waveNumberByLaunchDateMap = useMemo(function() {
        return waves.reduce(function(acc, wave) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, chartWaveLabels[wave.attributes.providable_id], wave.attributes.wave_number));
        }, {});
    }, [
        waves,
        chartWaveLabels
    ]);
    var xAxisTicks = useMemo(function() {
        return _to_consumable_array(data[0].data.map(function(wave) {
            return wave.x;
        }));
    }, [
        data
    ]);
    return /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "responsive-line-chart",
        bg: "white",
        w: "100%"
    }, /*#__PURE__*/ React.createElement(Box, {
        height: "400px"
    }, /*#__PURE__*/ React.createElement(ResponsiveLine, _object_spread({
        data: data,
        margin: {
            top: 50,
            right: 50,
            bottom: 50,
            left: 80
        },
        xScale: {
            type: 'point'
        },
        yScale: {
            type: 'linear',
            min: 'auto',
            max: upperLimit,
            stacked: false,
            reverse: false
        },
        useMesh: true,
        enableSlices: "x",
        animate: true,
        colors: _to_consumable_array(dataColors),
        axisTop: null,
        axisRight: null,
        axisBottom: {
            tickValues: xAxisTicks
        },
        axisLeft: {
            tickSize: 10,
            tickPadding: 5,
            tickRotation: 0,
            legend: usePercentage ? 'Responses %' : 'Responses',
            legendOffset: -50,
            legendPosition: 'middle',
            tickValues: usePercentage ? tickValues : 'auto'
        },
        pointSize: 16,
        pointLabelYOffset: 0,
        pointColor: {
            from: 'color'
        },
        pointSymbol: CustomPoint,
        pointBorderWidth: 2,
        pointBorderColor: {
            from: 'color'
        },
        sliceTooltip: function(props) {
            return /*#__PURE__*/ React.createElement(LineChartSliceTooltip, _object_spread_props(_object_spread({}, props), {
                visiblePoints: visiblePoints,
                usePercentage: usePercentage,
                waveNumber: waveNumberByLaunchDateMap[props.slice.points[0].data.x]
            }));
        }
    }, rest))), /*#__PURE__*/ React.createElement(Flex, null, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(LineChartLegend, {
        series: data,
        colors: dataColors,
        visiblePoints: visiblePoints,
        onItemClick: handleLegendClick,
        direction: legendDirection
    })), /*#__PURE__*/ React.createElement(Spacer, null), /*#__PURE__*/ React.createElement(CustomControlLegend, {
        type: customLegendType,
        controlProps: customLegendControlProps
    })));
};
var CustomPoint = function(param) {
    var size = param.size, color = param.color, borderWidth = param.borderWidth, borderColor = param.borderColor;
    return /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("circle", {
        fill: color === 'transparent' ? 'transparent' : '#FFF',
        r: size / 2,
        strokeWidth: borderWidth,
        stroke: borderColor
    }), /*#__PURE__*/ React.createElement("circle", {
        r: size / 4,
        strokeWidth: borderWidth,
        stroke: borderColor,
        fill: color,
        fillOpacity: 1
    }));
};
